'use client';
import * as React from 'react';
function useConstantCallback(callback) {
    const ref = React.useRef(callback);
    React.useEffect(() => {
        ref.current = callback;
    });
    return React.useCallback((...args) => ref.current.apply(null, args), []);
}
export { useConstantCallback };
